// Simple set of emoji pairs for initial difficulty
export const easyEmojis = [
  '🐶', '🐱', '🐰', '🐼', '🦊', '🐨', '🦁', '🐯',  // Animals
  '🍎', '🍌', '🍊', '🍇', '🍓', '🥝', '🍉', '🥭',  // Fruits
];

// More complex set for higher levels
export const advancedEmojis = [
  '🦮', '🐕', '🐈', '🐇', '🐼', '🦊', '🐨', '🦁',  // Similar animals
  '🍎', '🍏', '🍊', '🍋', '🫐', '🫑', '🥝', '🥥',  // Similar fruits
];

export interface CardImage {
  id: number;
  content: string;
  similarityGroup?: number;
}

export const generateCardImages = (level: number, size: { rows: number; cols: number }): CardImage[] => {
  const totalCards = size.rows * size.cols;
  const totalPairs = Math.floor(totalCards / 2);  // Number of complete pairs
  const hasOddCard = totalCards % 2 === 1;        // Check if odd number of cards
  
  const sourceEmojis = level <= 3 ? easyEmojis : advancedEmojis;
  
  // Take only the needed number of emojis for the current grid size
  const selectedEmojis = sourceEmojis.slice(0, totalPairs + (hasOddCard ? 1 : 0));
  
  // Create pairs of cards
  const cardImages: CardImage[] = [];
  selectedEmojis.forEach((emoji, index) => {
    if (index < totalPairs) {
      // Create two cards with the same emoji (pairs)
      cardImages.push(
        { id: index * 2, content: emoji, similarityGroup: index },
        { id: index * 2 + 1, content: emoji, similarityGroup: index }
      );
    } else {
      // Create single card for odd grids
      cardImages.push(
        { id: index * 2, content: emoji, similarityGroup: index }
      );
    }
  });
  
  return cardImages;
};